import React from "react";
import { LinkOutlined, SwapOutlined } from "@ant-design/icons";

// "2026-06" -> "06/2026"
const ymLabel = (ym) => {
  if (!ym || typeof ym !== "string") return "";
  const [y, m] = ym.split("-");
  return `${m}/${y}`;
};

// Tiny presentational component: renders a single (employee, week) cell
// in the Orari grid. Click → invokes onClick(weekStart, employeeId, assignment).
function WeekCell({ assignment, afternoonShiftId, shiftNameById, onClick, weekStart, employeeId }) {
  if (!assignment?.shiftId) {
    return (
      <span
        className="week-cell week-cell--empty"
        onClick={() => onClick?.(weekStart, employeeId, null)}
      >
        —
      </span>
    );
  }
  const isAfternoon = assignment.shiftId === afternoonShiftId;
  const name = shiftNameById?.[assignment.shiftId] || "Turn";
  const inherited = assignment.inheritedFromYearMonth;
  const borrowedFromTeam = assignment.borrowedFromTeam;
  const borrowedForTeam = assignment.borrowedForTeam;

  const titleParts = [name];
  if (assignment.locked && !inherited) titleParts.push("(i kyçur)");
  if (inherited) titleParts.push(`(vazhdim i javës nga ${ymLabel(inherited)})`);
  if (borrowedFromTeam && borrowedForTeam) {
    titleParts.push(`(hua nga ${borrowedFromTeam} për ${borrowedForTeam})`);
  }

  return (
    <span
      className={`week-cell ${isAfternoon ? "week-cell--afternoon" : ""} ${
        assignment.locked ? "week-cell--locked" : ""
      } ${inherited ? "week-cell--inherited" : ""} ${
        borrowedFromTeam ? "week-cell--borrowed" : ""
      }`}
      title={titleParts.join(" ")}
      onClick={() => onClick?.(weekStart, employeeId, assignment)}
    >
      {name}
      {inherited ? (
        <LinkOutlined
          className="week-cell__inherit-icon"
          style={{ marginLeft: 4, fontSize: 10 }}
        />
      ) : null}
      {borrowedFromTeam ? (
        <SwapOutlined
          className="week-cell__borrow-icon"
          style={{ marginLeft: 4, fontSize: 10 }}
        />
      ) : null}
    </span>
  );
}

export default WeekCell;
